import { PageHeader } from "@/components/design";
import { formatHours } from "@/features/dashboard/utils";
import { useDemo } from "../demo-context";
import { DEMO_SITES } from "../demo-data";

export function DemoDailyEntryPage() {
  const { state } = useDemo();
  const rows = state.dailyEntryRows;

  return (
    <div className="space-y-6">
      <PageHeader
        title="Daily Entry"
        description={`${DEMO_SITES.downtown.name} (${DEMO_SITES.downtown.code}) · Jun 23, 2026 · read-only preview`}
      />

      <div className="overflow-x-auto rounded-xl border bg-card-white shadow-[var(--shadow-card)]">
        <table className="min-w-[900px] w-full text-sm">
          <thead className="bg-navy-deep text-left text-xs uppercase tracking-wider text-white">
            <tr>
              <th className="px-4 py-3">Employee ID</th>
              <th className="px-4 py-3">Worker</th>
              <th className="px-4 py-3">Hours</th>
              <th className="px-4 py-3">Job</th>
              <th className="px-4 py-3">Cost</th>
              <th className="px-4 py-3">Flags</th>
              <th className="px-4 py-3">Equipment</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => {
              const flags = [
                row.flags.isNightShift ? "Night" : null,
                row.flags.isHazard ? "Hazard" : null,
                row.flags.isTraining ? "Training" : null,
                row.flags.isManualOvertime ? "Manual OT" : null,
              ].filter((flag): flag is string => Boolean(flag));

              return (
                <tr key={row.clientId} className="border-t hover:bg-bg-light/50">
                  <td className="px-4 py-3 font-mono text-xs font-semibold">{row.employeeId}</td>
                  <td className="px-4 py-3">
                    <p className="font-medium text-navy-deep">{row.workerName}</p>
                    {row.crew ? <p className="text-xs text-muted-foreground">{row.crew}</p> : null}
                  </td>
                  <td className="px-4 py-3 tabular-nums font-semibold">{formatHours(row.hours)}</td>
                  <td className="px-4 py-3 font-mono text-xs">{row.jobCode}</td>
                  <td className="px-4 py-3 font-mono text-xs">{row.costCode}</td>
                  <td className="px-4 py-3">
                    <div className="flex flex-wrap gap-1">
                      {flags.length === 0 ? (
                        <span className="text-muted-foreground">—</span>
                      ) : (
                        flags.map((flag) => (
                          <span
                            key={flag}
                            className="rounded-full bg-amber-100 px-2 py-0.5 text-[10px] font-semibold text-amber-900"
                          >
                            {flag}
                          </span>
                        ))
                      )}
                    </div>
                  </td>
                  <td className="px-4 py-3 text-xs text-muted-foreground">
                    {row.equipment.length > 0
                      ? row.equipment.map((e) => `${formatHours(e.usageHours)} hrs`).join(", ")
                      : "—"}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      <p className="text-sm text-muted-foreground">
        Site managers enter hours, job codes, equipment usage, and flags. Werkio applies pay
        rules automatically — no spreadsheet formulas required.
      </p>
    </div>
  );
}
